import { FC, useMemo } from 'react';
import {Field} from '@progress/kendo-react-form';

import binIcon from '../../../../assets/bin.svg';
import styles from './CustomerContact.module.scss';
import { ICustomerContact } from '../../../../model';
import {
  emailValidator,
  FormInput,
  FormTextArea,
  requiredValidator,
  TextFormField, usPhoneMaskValidator
} from '../../../common';
import { ExternalURLTextFormField } from '../../../common/forms/text-form-field/ExternalURLTextFormField';
import {MaskedFormInput} from "../../../common/forms/masked-form-input/MaskedFormInput";

interface IProps {
  index: number;
  customerContact: ICustomerContact;
  onDelete?: (index: number) => void | undefined;
  edit?: boolean;
  hideDeleteButton?: boolean;
}

const CustomerContact: FC<IProps> = ({ customerContact, index, hideDeleteButton, edit, onDelete }) => {
  const content = useMemo(
    () => (
      <div className={styles.content}>
        <div className={styles.panel}>
          {!!edit && !hideDeleteButton && (
            <button
              onClick={(e) => {
                e.preventDefault();
                if (onDelete) {
                  onDelete(index);
                }
              }}
              className={styles.bin}
            >
              <img src={binIcon} alt='bin' />
            </button>
          )}
          <div className={styles.row}>
            <Field
              required={true}
              validator={requiredValidator}
              name={`customerContacts[${index}].firstName`}
              label={'First Name'}
              maxLength={256}
              component={edit ? FormInput : TextFormField}
            />
            <Field
              name={`customerContacts[${index}].lastName`}
              label={'Last Name'}
              maxLength={256}
              required={true}
              validator={requiredValidator}
              component={edit ? FormInput : TextFormField}
            />
          </div>
          <div className={styles.row}>
            <Field
              name={`customerContacts[${index}].jobTitle`}
              label={'Job Title'}
              maxLength={256}
              component={edit ? FormInput : TextFormField}
            />
          </div>
          <div className={styles.row}>
            <Field
              name={`customerContacts[${index}].email`}
              label={'Email'}
              maxLength={320}
              validator={emailValidator}
              type='email'
              href={`mailto:${customerContact?.email ?? ''}`}
              component={edit ? FormInput : ExternalURLTextFormField}
            />
            <Field
              name={`customerContacts[${index}].phoneNumber`}
              label={'Phone Number'}
              validator={usPhoneMaskValidator}
              type='tel'
              maxLength={256}
              href={`tel:${customerContact?.phoneNumber ?? ''}`}
              component={edit ? MaskedFormInput : ExternalURLTextFormField}
              multiple
              mask="(999) 000-0000"
            />
          </div>
        </div>
        <div className={styles.panel}>
          <Field
            className={styles.comment}
            name={`customerContacts[${index}].comment`}
            label={'Comment'}
            maxLength={512}
            rows={5}
            component={edit ? FormTextArea : TextFormField}
          />
        </div>
      </div>
    ),
    [customerContact?.email, customerContact?.phoneNumber, edit, index, onDelete],
  );

  return content;
};

export default CustomerContact;
